﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppVX = void 0;
const GUIController_1 = require("./appControllers/GUIController");
const StateDashboard_1 = require("./states/StateDashboard");
const gs_1 = require("@ivanlog/gs");
const StateApp_1 = require("./states/abstracts/StateApp");
const StateLoading_1 = require("./states/StateLoading");
const DesignThemeEnum_1 = require("./enums/DesignThemeEnum");
const Web3Controller_1 = require("./appControllers/Web3Controller");
class AppVX {
    constructor() {
        AppVX.Inst = this;
        StateApp_1.StateUp.App = this;
        gs_1.StateGS.DefaultStateName = 'loading';
        this.gui = new GUIController_1.GUIController(this);
        this.chain = new Web3Controller_1.Web3Controller(this);
        this.gui.setTheme(DesignThemeEnum_1.DesignThemeEnum.LightGrey);
        this.start();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            gs_1.StateGS.RegState(StateLoading_1.StateLoading);
            gs_1.StateGS.RegState(StateDashboard_1.StateDashboard);
            gs_1.StateGS.DefaultStateName = StateDashboard_1.StateDashboard.StateName;
            yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            yield this.chain.start();
            if (this.chain.isConnected) {
                yield gs_1.StateGS.Run(StateDashboard_1.StateDashboard);
                // const byUrl = await StateGS.RunByUrl()
                // if (byUrl === StateRunResultEnum.Failed) 
            }
            else {
                yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            }
        });
    }
    awaitTime(timeMS) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), timeMS);
        });
    }
}
exports.AppVX = AppVX;
AppVX.ADDRESS_VController = "0x287468e181A30d8961a0a01f279185E9C6FE0d97";
//public static CHAIN_RPC:string="https://rpc.pulsechain.com"
AppVX.CHAIN_RPC = "https://rpc.v4.testnet.pulsechain.com";
AppVX.CHAIN_ID = 943;
AppVX.version = "0.0.1";
//# sourceMappingURL=AppVX.js.map